import { Link, Paper, Typography } from "@mui/material";
import { Box, Stack } from "@mui/system";
import React from "react";
import ItemImage from "./ItemImage";
import { useMediaQuery } from "react-responsive";

const HEADING_FONT = '"Inter", "Roboto", "Helvetica", sans-serif';

const ExploreGearCard = ({ link, imageUrl, text }) => {
  const isMobile = useMediaQuery({ maxWidth: 898 });

  return (
    <Link href={link} sx={{ textDecoration: "none" }}>
      <Paper
        elevation={0}
        sx={(theme) => {
          const isDark = theme.palette.mode === "dark";
          return {
            height: !isMobile ? "210px" : "250px",
            width: !isMobile ? "250px" : "300px",
            margin: "0 auto",
            borderRadius: "16px",
            overflow: "hidden",
            border: `1px solid ${
              isDark ? "rgba(255,255,255,0.1)" : "rgba(0,0,0,0.08)"
            }`,
            backgroundColor: isDark ? "#333333" : "#FFFFFF",
            backgroundImage: "none",
            transition:
              "transform 0.25s ease, box-shadow 0.25s ease, border-color 0.25s ease",
            "&:hover": {
              transform: "translateY(-6px)",
              cursor: "pointer",
              boxShadow: isDark
                ? "0 18px 36px rgba(0,0,0,0.45)"
                : "0 18px 36px rgba(25,118,210,0.14)",
              borderColor: isDark
                ? "rgba(144,202,249,0.45)"
                : "rgba(25,118,210,0.35)",
            },
          };
        }}
      >
        <Stack>
          <Box
            sx={{
              width: !isMobile ? "250px" : "300px",
              height: !isMobile ? "150px" : "200px",
              position: "relative",
            }}
          >
            <ItemImage
              style={{
                maxWidth: !isMobile ? "150px" : "280px",
                maxHeight: !isMobile ? "130px" : "180px",
                position: "absolute",
                margin: "auto",
                top: "0",
                bottom: "0",
                left: "0",
                right: "0",
              }}
              iconSize={28}
              src={imageUrl}
              alt={text}
            />
          </Box>
          <Typography
            sx={{
              textAlign: "center",
              fontFamily: HEADING_FONT,
              fontWeight: 600,
              fontSize: "14.5px",
              padding: "10px 12px",
            }}
          >
            {text}
          </Typography>
        </Stack>
      </Paper>
    </Link>
  );
};

export default ExploreGearCard;
